module.exports = __webpack_public_path__ + "img/bind-success.73b23e6a.png";